import { OrganizationStage } from 'entities-next/fundingRounds'

export const OrganizationStageToStageLabels: {
  [key in OrganizationStage]: string
} = {
  [OrganizationStage.Acquired]: 'Acquired/Merged',
  [OrganizationStage.Corporate_Round]: 'Corporate Round',
  [OrganizationStage.Debt_Financing]: 'Debt Financing',
  [OrganizationStage.Pre_Seed]: 'Pre-Seed',
  [OrganizationStage.Private_Equity]: 'Private Equity',
  [OrganizationStage.Public]: 'Public',
  [OrganizationStage.Seed]: 'Seed',
  [OrganizationStage.Series_A]: 'Series A',
  [OrganizationStage.Series_B]: 'Series B',
  [OrganizationStage.Series_C]: 'Series C',
  [OrganizationStage.Series_D]: 'Series D',
  [OrganizationStage.Series_E]: 'Series E',
  [OrganizationStage.Series_F]: 'Series F+',
  [OrganizationStage.Series_Unknown]: 'Series Unknown',
  [OrganizationStage.Other]: 'Other',
} as const

export const StageLabelsToOrganizationStage: {
  [key in typeof OrganizationStageToStageLabels[OrganizationStage]]: OrganizationStage
} = Object.keys(OrganizationStageToStageLabels).reduce((map, key) => {
  const value = OrganizationStageToStageLabels[key]
  map[value] = key
  return map
}, {})

/**
 * Map a organization stage into the equivalent stage identifier.
 * If the stage identifier is not defined return the same stage provided.
 *
 * @export
 * @param {string} stage the stage value to parse.
 * @return {*}  {string}
 */
export function organizationStageToOrganizationStageLabel(
  stage: OrganizationStage
): typeof OrganizationStageToStageLabels[OrganizationStage] {
  return OrganizationStageToStageLabels[stage] ?? stage
}

export function organtizationStageLabelTorganizationStage(
  stage: typeof OrganizationStageToStageLabels[OrganizationStage]
): OrganizationStage {
  return StageLabelsToOrganizationStage[stage] ?? stage
}
